import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';

import { AtividadeMaterial } from '../models/atividade-material';
import { AtividadeMensagens } from '../models/atividade-mensagens';

@Injectable({
  providedIn: 'root',
})
export class AtividadeMensagensService {
  private environmentUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore;
  }

  // getAtividadeMateriais(idAtividade: number) : Observable<AtividadeMaterial[]> {

  //     let url = this.environmentUrl + "Atividade/" + idAtividade + "/Material" ;
  //     return this.httpClient.get<AtividadeMaterial[]>(url);
  // }

  getAtividadeMensagens(idAtividade: number): Observable<AtividadeMensagens[]> {
    const url = this.environmentUrl + 'v3/atividade/' + idAtividade + '/mensagem';
    return this.httpClient.get<AtividadeMensagens[]>(url);
  }

  insertAtividadeMensagens(idAtividade: any, body: any) {
    const url = this.environmentUrl + `v3/atividade/${idAtividade}/mensagem `;
    return this.httpClient.post(url, body);
  }
}
